var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77687 6.69648V6.69648C6.03118 6.05443 5.84754 4.97279 6.33955 4.12061L6.8335 3.26507C7.66192 1.83019 9.49669 1.33857 10.9316 2.16699L11.5089 2.50033C12.9438 3.32875 13.4354 5.16352 12.607 6.5984L12.1131 7.45394C11.621 8.30612 10.5925 8.68791 9.66362 8.36314V8.36314",
    stroke: "#73756D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66356 9.86895V9.86895C9.40925 10.511 9.59289 11.5926 9.10088 12.4448L8.60693 13.3004C7.77851 14.7352 5.94373 15.2269 4.50886 14.3984L3.93151 14.0651C2.49663 13.2367 2.005 11.4019 2.83343 9.96703L3.32738 9.11149C3.81938 8.25931 4.84793 7.87752 5.77681 8.20229V8.20229",
    stroke: "#73756D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88672 4.53027L5.55339 12.0358",
    stroke: "#73756D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_link.cc8f73e769b001a5f594260c8fba4607.svg";